import fetch from 'node-fetch';
import debugLib from 'debug';
import Promise from 'bluebird';
import _ from 'lodash';
import { cachePromise } from '../util/decorators';
import config from '../config';

const debug = debugLib('vs3:service:sportBackend');
debug.log = console.info.bind(console);

const { SDS_URL } = config;
const TIMEOUT = 5000;
const REQUEST_BATCH_TIME = 5 * 60 * 60 * 1000;

// Inject MSP API Headers with webpack. The headers are diffrent for client/server.
// Server headers should not be readable in the client bundle.
const MSP_API_HEADERS = __WEBPACK_INJECTED_MSP_HEADERS__; // eslint-disable-line no-undef

function fetchFromMspAPI(url) {
  return Promise.resolve(fetch(url, { headers: MSP_API_HEADERS, timeout: TIMEOUT })).then(res => res.json());
}

const api = {
  @cachePromise(REQUEST_BATCH_TIME)
  getEvents(eventIds, competitionIds, lang) {
    debug('getEvents');

    // The sds uses "no" instead of specifying nb or nn
    const language = lang === 'nb' ? 'no' : lang;

    const fetchEventsByCompetition = competitionId => fetchFromMspAPI(`${SDS_URL}/${language}/competitions/${competitionId}/events`).then(result => result.data);
    console.log(`fetchEventsByCompetition:  ` + `${SDS_URL}/${language}/competitions/${competitionId}/events`);
    const filterEvents = events => _.filter(events, event => _.includes(eventIds, event.id));
    const removeDuplicateEvents = events => _.uniqBy(events, 'id');
    const promises = _.map(competitionIds, fetchEventsByCompetition);

    return Promise.all(promises)
      .then(_.flatten)
      .then(removeDuplicateEvents)
      .then(filterEvents);
  },

  @cachePromise(REQUEST_BATCH_TIME)
  fetchTeamsByLeagueIds(lang, leagueIds) {
    debug('fetchTeamsByLeagueIds', leagueIds);

    // The sds uses "no" instead of specifying nb or nn
    const language = lang === 'nb' ? 'no' : lang;

    const fetchCurrentSeason = id => fetchFromMspAPI(`${SDS_URL}/${language}/leagues/${id}/seasons`).then(result => result.data[0].id);
    const fetchCompetitionsInSeason = id => fetchFromMspAPI(`${SDS_URL}/${language}/seasons/${id}/competitions`).then(result => _.map(result.data, 'id'));
    const fetchTeamsInCompetition = competitionId => fetchFromMspAPI(`${SDS_URL}/${language}/competitions/${competitionId}/teams`);
    const fetchTeamsInCompetitions = competitionIds => Promise.all(competitionIds.map(fetchTeamsInCompetition));
    const filterUniqueAndSort = competitionsWithTeams =>
       _(competitionsWithTeams).map('data').flatten().uniqBy('id').sortBy('name').value();

    const promises = _.map(leagueIds, id =>
        fetchCurrentSeason(id)
        .then(fetchCompetitionsInSeason)
        .then(fetchTeamsInCompetitions)
        .then(filterUniqueAndSort)
        .then(teams => ({ [id]: teams }))
    );

    return Promise.all(promises).then(result => _.merge({}, ...result));
  },
};

export default api;



// WEBPACK FOOTER //
// ./src/service/sportBackend.js